export default __webpack_public_path__ + "static/media/RFI.b6944de9.png";